import useSWRImmutable from 'swr';
import type { AxiosError } from 'axios';
import axios from 'axios';

import type { ILabelValuePair } from '../../components/marking/MarkingInterfaces';

const GetScreenlessBinNames = ():{ binNames: ILabelValuePair[] | undefined,
  isLoading: boolean,
  isError: boolean, } => {
  const fetcher = (url: string) => axios.get<ILabelValuePair[]>(url)
    .then((response) => response.data);

  const { data, error } = useSWRImmutable<ILabelValuePair[], AxiosError>('/Scanner/GetScreenlessBinNames',
    (url) => fetcher(url));

  return {
    binNames: data,
    isLoading: !error && !data,
    isError: Boolean(error),
  };
};

export default GetScreenlessBinNames;
